// ===============================================================
// ⭐ TopBar2.js — Back Only (FINAL / LOCKED)
// No language or direction logic (LIVORA safe)
// ===============================================================

import React from "react";
import { useTranslation } from "react-i18next";
import "./TopBar2.css";

export default function TopBar2({ onBack, side = "left" }) {
  const { t } = useTranslation();

  if (!onBack) return null;

  return (
    <button
      className={`topbar2-back-only topbar2-side-${side}`}
      onClick={onBack}
      aria-label={t("common.back", { defaultValue: "Back" })}
    >
      <span className="topbar2-icon">›</span>
    </button>
  );
}
